module.exports = __webpack_public_path__ + "static/media/skype-icon.3b08be84.svg";